import { useSyncExternalStore } from 'react';

/**
 * Ошибки телефона для колокольчика шапки (header1, 04.10.2026).
 *
 * Их источник — пульт над маршрутами: он знает и причину, и действие. Колокольчик
 * живёт в каркасе, который рисуется и без телефонии, поэтому читает не контекст
 * телефона, а этот общий снимок. Второго состояния телефона здесь нет — только
 * то, что пульт показал бы сам.
 */
export interface PhoneAlerts {
  errors: string[];
  /** Повторить подключение; `null` — действие сейчас недоступно (идёт разговор, подключение). */
  reconnect: (() => void) | null;
}

const EMPTY: PhoneAlerts = { errors: [], reconnect: null };
let current: PhoneAlerts = EMPTY;
const listeners = new Set<() => void>();

export function publishPhoneAlerts(next: PhoneAlerts): void {
  const same = next.reconnect === current.reconnect
    && next.errors.length === current.errors.length
    && next.errors.every((e, i) => e === current.errors[i]);
  if (same) return;
  current = next.errors.length === 0 && next.reconnect === null ? EMPTY : next;
  listeners.forEach((l) => l());
}

export function usePhoneAlerts(): PhoneAlerts {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    () => current,
    () => EMPTY,
  );
}
